const isGlobalAdmin = (user: any) => {
  return user?.isGlobalAdmin;
};

export default isGlobalAdmin;
